import PageLayout from "../../../_components/PageLayout";
import MyButton from "../../../_components/MyButton";
import { Box, Stack, useTheme } from "@mui/material";
import { useSwiper } from "swiper/react";
import BesmartAnimation from "../components/BesmartAnimation/BesmartAnimation";
import Text from "../../../_components/Text";

const OnboardingWelcome = () => {
  const theme = useTheme();

  const swiper = useSwiper();
  const handleSlideNext = () => swiper.slideNext();

  return (
    <PageLayout
      bottomButton={
        <MyButton withPaper onClick={handleSlideNext}>
          Get started
        </MyButton>
      }
    >
      <Box
        className="layout"
        sx={{
          backgroundColor: theme.myTheme.colors.bg,
          borderTopLeftRadius: "12px",
          borderTopRightRadius: "12px",
          padding: "8px 8px 0",
        }}
      >
        <BesmartAnimation />
        <Stack 
					direction="column" 
					spacing={3} 
					alignItems="center"
				>
					<Text variant="h1">
						Welcome to BeSmart
					</Text>
					<Text variant="regular" align="center">
            Your crypto tool with a simple interface that helps you<br />manage assets and generate returns
					</Text>
				</Stack>
      </Box>
    </PageLayout>
  );
};

export default OnboardingWelcome;
